// Created by Michael Abadi Santoso
// 25 May 2020
// Copyright OKKAMI

///
/// Use this class for generating component globally
///
import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

// Use this for Global List style
const List = styled.div`
  margin: 20px 50px;
  padding: 0 0 5rem 0;
`;

// Use this for Global Row style
const ListRow = styled.div`
  display: flex;
  line-height: 24px;
  white-space: nowrap;
  margin: 10px 0;
  padding: 10px;
  background: #ffffff;
  border-bottom: 1px solid #e3e3e3;
`;

// Use this for Bottom border
const BorderBottom = styled.div`
  border-bottom: ${(props) =>
    props.thickness
      ? props.thickness + "px solid #e3e3e3"
      : "2px solid #e3e3e3"};
`;

// Use this for Global Section List style
const ListSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

// Use this for Global Bottom Bar style
const BottomBar = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  background: #2d3436;
  z-index: 1;
  font-size: 1.4rem;
`;

// Use this for Global Flex Container style
const FlexContainer = styled.div`
  max-width: 120rem;
  display: flex;
  margin: auto;
  padding: 0 2rem;
  justify-content: space-between;
  height: 5rem;
`;

const StyledLink = styled(Link)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const StyledA = styled.a`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const ItemLink = styled.div`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const Container = styled.div`
  padding: 0 0 5rem 0;
`;

// Use this for convenient Flex style
const Flex = (props) => (
  <div
    className={props.className}
    style={{
      display: props.container ? "flex" : "block",
      justifyContent: props.justifyContent || "flex-start",
      flexDirection: props.flexDirection || "row",
      flexGrow: props.flexGrow || 0,
      flexBasis: props.flexBasis || "auto",
      flexShrink: props.flexShrink || 1,
      flexWrap: props.flexWrap || "nowrap",
      flex: props.flex || "0 1 auto",
      alignItems: props.alignItems || "stretch",
      margin: props.margin || "0",
      padding: props.padding || "0",
      width: props.width || "auto",
      height: props.height || "auto",
      maxWidth: props.maxWidth || "none",
      backgroundColor: props.backgroundColor || "transparent",
      position: props.position || "relative",
    }}>
    {props.children}
  </div>
);

export {
  List,
  ListRow,
  BottomBar,
  FlexContainer,
  Flex,
  ListSection,
  StyledLink,
  Container,
  BorderBottom,
  ItemLink,
  StyledA,
};
